import qs from 'qs';
import { DateFormatter } from '@/shared/lib/calendar';

export const PetsCalculateParams = () => {
  const { formatDate } = DateFormatter();

  const preparePetsCalculationQueryParams = ({ startFrom, insurancePeriod, earnings }) => {
    return qs.parse(qs.stringify({
      startFrom: formatDate(startFrom),
      insurancePeriod,
      earnings,
    }, {
      encoder: (str) => encodeURIComponent(str),
      encodeValuesOnly: true,
      skipNulls: true,
    }));
  };

  return {
    preparePetsCalculationQueryParams,
  };
};